module.exports = __webpack_public_path__ + "h5/img/mfe_01.9daf26a0.jpeg";